import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { faker } from '@faker-js/faker';

import { DateTime } from 'luxon';
import { useState } from 'react';
import { CHECKINTYPE } from '../constants';
import QueuesService from '../services/queues.service'
import CheckinsService from '../services/checkins.service';
import queuescheckin from '../_mock/queuescheckin';

const randomUsers = queuescheckin.slice(0, 10)

export default function Demo() {

  const [minutesOffset, setMinutesOffset] = useState(0 * 60);

  return (

    <Stack spacing={2} direction="column" sx={{ m:2, p:1}}>
      <Stack spacing={2} direction="row" sx={{ m:2, p:1}}>
      <Button variant="contained" onClick={() => {
        const timestamp = DateTime.local().plus({minute:minutesOffset}).startOf('hour').valueOf().toString()
        const user = faker.helpers.arrayElements(randomUsers, 1)[0]

          QueuesService.createQueue({timestamp, user})
      }}>จอง</Button>
      <Button variant="outlined" onClick={() => {
        const timestamp = DateTime.local().plus({minute:minutesOffset}).startOf('hour').valueOf().toString()
        const user = faker.helpers.arrayElements(randomUsers, 1)[0]
        const checkintype = Object.values(CHECKINTYPE)[Math.round(Math.random() * Object.values(CHECKINTYPE).length).toFixed()].name

          CheckinsService.createCheckin({timestamp, user, checkintype})
      }}>เช็คอิน</Button>      
      </Stack>
    </Stack>
  );
}